import { render, staticRenderFns } from "./label_barcode.vue?vue&type=template&id=f4aad0fe&scoped=true&"
import script from "./label_barcode.vue?vue&type=script&lang=js&"
export * from "./label_barcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4aad0fe",
  null
  
)

export default component.exports